import { addActionBarItem } from '@vendure/admin-ui/core';
import gql from 'graphql-tag';
import { firstValueFrom } from 'rxjs';
import { map as rxMap } from 'rxjs/operators';

const mutation = gql`
    mutation MyMutation($customerId: String!) {
        createSellerToken(input: { customer_id: $customerId }) {
            ... on CreateTokenResult {
                url
                token
                sellerId
            }
            ... on NoSellerAssignedError {
                errorCode
                message
            }
        }
    }
`;

export default [
    addActionBarItem({
        id: 'sellers-ui',
        locationId: 'customer-detail',
        icon: 'assign-user',
        label: 'Acessar loja como cliente',

        buttonState: (context) => {
            return context.entity$.pipe(
                rxMap((entity: any): any => {
                    const verified = entity?.user?.verified;
                    const profileStatus = entity?.customFields?.profileAnalysis;

                    if (!verified) {
                        return {
                            disabled: true,
                            tooltip:
                                'Cliente não verificado. Verifique o e-mail antes de acessar a loja.',
                        };
                    }

                    if (profileStatus !== 'approved') {
                        return {
                            disabled: true,
                            tooltip: `Perfil em análise: status atual "${profileStatus}".`,
                        };
                    }

                    return { disabled: false };
                })
            );
        },

        onClick: async (event, context) => {
            const entity = await firstValueFrom(context.entity$);
            const customerId = entity?.id;

            try {
                const response: any = await firstValueFrom(
                    context.dataService.mutate(mutation, {
                        customerId,
                    })
                );

                if ('errorCode' in response.createSellerToken) {
                    const { errorCode, message } = response.createSellerToken;
                    context.notificationService.error(
                        'Erro: ' + errorCode + ': ' + message
                    );
                }

                if ('token' in response.createSellerToken) {
                    const { url, token, sellerId } = response.createSellerToken;
                    window.open(`${url}${token}?sellerId=${sellerId}`);
                }
            } catch (error: any) {
                context.notificationService.error(
                    'Erro ao executar mutation: ' + error.message
                );
            }
        },

        requiresPermission: 'ReadShoppingList',
    }),
];
